// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Recebimentos_ParcelaEdicaoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Item de Recebimentos_SalvarParcelasInput::$parcelas — o que se edita em UMA parcela de uma venda
 * parcelada (chamado 2026-0067): a taxa que o adquirente cobrou nela. O valor da parcela não se
 * edita (a soma das parcelas é a venda), nem a data em que ela fica disponível (vem do prazo da
 * forma, ou do provedor). Campo ausente = não muda.
 */
import { registerContract } from './validate'

export interface Recebimentos_ParcelaEdicaoInput {
recebimento_id: number
recebimento_valor_taxas?: number
}

registerContract('Recebimentos_ParcelaEdicaoInput', {
  recebimento_id:          { type: 'number',  required: true },
  recebimento_valor_taxas: { type: 'number',  required: false },
})
